import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import profile from './locales/en/profile.json';
import security from './locales/en/security.json';
import sideBar from './locales/en/sideBar.json';
import app from './locales/en/app.json';
import apps from './locales/en/apps.json';
import header from './locales/en/header.json';
import profileEs from './locales/es/profile.json';
import securityEs from './locales/es/security.json';
import sideBarEs from './locales/es/sideBar.json';
import appEs from './locales/es/app.json';
import appsEs from './locales/es/apps.json';
import headerEs from './locales/es/header.json';
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    fallbackLng: 'en',
    resources: {
        en: {
            profile,
            security,
            sideBar,
            app,
            apps,
            header
        },
        es: {
            profile: profileEs,
            security: securityEs,
            sideBar: sideBarEs,
            app: appEs,
            apps: appsEs,
            header: headerEs
        }
    },
    ns: ['profile', 'security', 'sideBar', 'app', 'apps', 'header'],
    defaultNS: 'app',
    interpolation: {
        escapeValue: false
    },
    react: {
        useSuspense: false
    },
    detection: {
        order: ['navigator']
    }
});
export default i18n;
